<div class="list-item">

    <div class="details">
        <span class="title" (click)="actionClickFile(file,$event)">{{file.name}}</span>
        <span class="download-icon" title="Download" (click)="actionDownloadClick(file,$event)"></span>
        <span class="size">({{file.filesize}})</span>
        <span class="ext">{{file.extension}}</span>
    </div>
    
    <core-helpers-navigation-three-dots-menu [menu]="menu" (action)="onMenuSelect($event)"></core-helpers-navigation-three-dots-menu>

</div>
    